<div class="text-center" id="presentation">
    <div class="services-container text-center  ui container">
        <h2>Nos services de locations</h2>
        <div class="ui stackable three column grid">
            <leasing *ngFor="let leasing of leasings.Value()"
                     [leasing]="leasing"
                     (booked)="openUserReservationDialog($event)"
                     class="column"></leasing>
        </div>
    </div>
    <leasing-userReservation #userReservationDialog></leasing-userReservation>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/presentation.html